import { AutopilotSidebar as BaseAutopilotSidebar } from 'screens/VirtualMarketerOnboarding/AutopilotSidebar/AutopilotSidebar'

export const AutopilotSidebar = () => {
  return (
    <BaseAutopilotSidebar
      sections={[
        {
          heading: 'Topics that convert',
          text: 'Blaze generated engaging topics from your Brand Kit. Edit as needed. We’ll adapt each for the right platform and add more if you increase posting frequency.',
        },
        {
          heading: 'Refine your list',
          text: "Click any topic to edit. Delete anything that doesn't fit. Need help perfecting your topics? Book a quick 1:1 call with our team.",
        },
      ]}
    />
  )
}
